import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { IChallengeStats } from './challenge-stats-schema';
import { challengeStatsSchema } from './challenge-stats-schema';

type ResponseType = IAPI<IChallengeStats | null>;

const responseSchema = createApiResponseSchema(
  challengeStatsSchema.nullable(),
) as z.ZodSchema<ResponseType>;

export async function getChallengeStatsApi(id: number) {
  return getRequest<ResponseType>({
    path: `/challenges/${id}/stats`,
    schema: responseSchema,
  });
}
